
import xss from 'xss';

export const filterXSS = (str, ignoreClass, ignoreId) => {
  return xss(str || '', {
    stripIgnoreTagBody: true, // 不在白名单中的标签以及标签里面的内容直接删除
    whiteList: {
      h1: ['style'],
      h2: ['style'],
      h3: ['style'],
      h4: ['style'],
      h5: ['style'],
      h6: ['style'],
      hr: ['style'],
      span: ['style'],
      strong: ['style'],
      font: ['style', 'size'],
      b: ['style'],
      i: ['style'],
      br: [],
      p: ['style'],
      pre: ['style'],
      code: ['style'],
      a: ['style', 'target', 'href', 'title', 'rel'],
      img: [
        'style',
        'src',
        'title',
        ...(ignoreClass ? ['class'] : []),
        ...(ignoreId ? ['id'] : []),
        'width',
        'height'
      ],
      div: [
        'style',
        ...(ignoreClass ? ['class'] : []),
        ...(ignoreId ? ['id'] : [])
      ],
      table: ['style', 'width', 'border'],
      tr: ['style'],
      td: ['style', 'width', 'colspan'],
      th: ['style', 'width', 'colspan'],
      tbody: ['style'],
      ul: ['style'],
      li: ['style'],
      ol: ['style'],
      dl: ['style'],
      dt: ['style'],
      em: ['style'],
      cite: ['style'],
      section: ['style'],
      header: ['style'],
      footer: ['style'],
      blockquote: ['style'],
      audio: ['autoplay', 'controls', 'loop', 'preload', 'src'],
      video: [
        'autoplay',
        'controls',
        'loop',
        'preload',
        'src',
        'height',
        'width',
        'source'
      ],
      source: ['type', 'src'],
      style: []
    },
    onTagAttr: function (tag, attr, value) {
      if (attr === 'href' || attr === 'src') {
        if (/\/\*|\*\//gm.test(value)) {
          return '#';
        }
        if (
          /^[\s"'`]*((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi.test(
            value
          )
        ) {
          return '#';
        }
      } else if (attr === 'style' || attr === 'class') {
        if (/\/\*|\*\//gm.test(value)) {
          return '#';
        }
        if (
          /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi.test(
            value
          )
        ) {
          return '';
        }
        return `${attr}="${value}"`;
      }
    }
  });
};